/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Recording_Auto_StopInputs */



/**
* | output |
* | --- |
* | "Recording will stop automatically at event end time" |
*
* @param {Audio_Recorder_Recording_Auto_StopInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_recording_auto_stop = /** @type {((inputs?: Audio_Recorder_Recording_Auto_StopInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Recording_Auto_StopInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'enregistrement s'arrêtera automatiquement à la fin de l'événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Aufzeichnung wird automatisch zum Ende der Veranstaltung gestoppt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La registrazione si interromperà automaticamente al termine dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запись автоматически остановится по окончании мероприятия.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La grabación se detendrá automáticamente al finalizar el evento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("录制将在活动结束时自动停止。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント終了時に録画は自動的に停止します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समाप्त होने पर रिकॉर्डिंग अपने आप बंद हो जाएगी।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A gravação será interrompida automaticamente ao término do evento.")
	return /** @type {LocalizedString} */ ("Recording will stop automatically at event end time")
});